<ng-container>
	<div class="flex justify-center items-center w-full h-full min-h-[500px] flex-col">
		<h3>Face Validation</h3>
		<p class="text-gray-600">
			Please take <strong>{{ numberOfImages }} clear picture(s)</strong> of yourself in a <strong>well-lit room</strong> to verify
			your identity. (Score should be at least 0.8)
		</p>
		<div>
			<div class="relative" id="face-capture-container">
				<video class="relative" autoplay height="300" id="video" muted width="398"></video>
			</div>
			<div class="camera-shutter flex items-center justify-center relative h-0 top-[-36px]">
				<ng-container *ngIf="!loadingModels; else loading">
					<span (click)="snap()" *ngIf="images.length < numberOfImages" class="shutter">
						<svg fill="none" height="40" viewBox="0 0 41 40" width="41" xmlns="http://www.w3.org/2000/svg">
							<circle cx="20.4998" cy="19.9998" fill="#0361F0" r="16.8182" />
							<circle cx="20.5" cy="20" r="19.1307" stroke="#0361F0" stroke-width="1.26136" />
							<path
								clip-rule="evenodd"
								d="M15.5463 15.0754C15.0758 15.0754 14.6246 15.2652 14.292 15.6032C13.9593 15.9411 13.7725 16.3994 13.7725 16.8773V24.0851C13.7725 24.563 13.9593 25.0214 14.292 25.3593C14.6246 25.6972 15.0758 25.8871 15.5463 25.8871H26.189C26.6594 25.8871 27.1106 25.6972 27.4433 25.3593C27.7759 25.0214 27.9628 24.563 27.9628 24.0851V16.8773C27.9628 16.3994 27.7759 15.9411 27.4433 15.6032C27.1106 15.2652 26.6594 15.0754 26.189 15.0754H24.7824C24.5472 15.0753 24.3216 14.9804 24.1554 14.8114L23.1611 13.8014C22.8286 13.4635 22.3775 13.2735 21.9071 13.2734H19.8282C19.3578 13.2735 18.9067 13.4635 18.5741 13.8014L17.5799 14.8114C17.4136 14.9804 17.1881 15.0753 16.9529 15.0754H15.5463ZM20.8676 23.1842C21.217 23.1842 21.563 23.1142 21.8858 22.9784C22.2086 22.8426 22.502 22.6435 22.749 22.3925C22.9961 22.1415 23.1921 21.8435 23.3258 21.5156C23.4595 21.1877 23.5283 20.8362 23.5283 20.4812C23.5283 20.1263 23.4595 19.7748 23.3258 19.4469C23.1921 19.1189 22.9961 18.821 22.749 18.57C22.502 18.319 22.2086 18.1199 21.8858 17.9841C21.563 17.8482 21.217 17.7783 20.8676 17.7783C20.162 17.7783 19.4852 18.0631 18.9862 18.57C18.4873 19.0769 18.2069 19.7644 18.2069 20.4812C18.2069 21.1981 18.4873 21.8856 18.9862 22.3925C19.4852 22.8994 20.162 23.1842 20.8676 23.1842Z"
								fill="white"
								fill-rule="evenodd"
							/>
						</svg>
					</span>
				</ng-container>
				<ng-template #loading>
					<app-kamona-loading></app-kamona-loading>
				</ng-template>
			</div>
		</div>

		<div>
			<div nz-col nzSpan="24">
				<div class="mt-8 mb-5 grid grid-cols-2 gap-4" nz-row>
					<ng-container *ngFor="let item of images; let i = index">
						<div class="gutter-row flex-container j-c-center" nz-col>
							<div class="w-auto h-24 bg-black rounded-lg flex justify-center items-center text-lg">
								<div *ngIf="!item" class="placeholder">
									<i nz-icon nzTheme="outline" nzType="picture"></i> Photo {{ i }}
								</div>
								<ng-container *ngIf="item">
									<img [src]="item" [width]="150" alt="" />
									<i (click)="removePhoto(item)" class="close" nz-icon nzTheme="fill" nzType="close-circle"></i>
								</ng-container>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
		<app-kamona-custom-error-display [errorMessage]="error"></app-kamona-custom-error-display>
		<div class="mt-4" style="width: 100%">
			<div class="grid grid-cols-2 gap-4">
				<div class="gutter-row" nz-col>
					<button (click)="back.emit()" class="btn btn-secondary btn-block">Cancel</button>
				</div>

				<div class="gutter-row" nz-col>
					<app-kamona-custom-button
						class="face-capture-continue-button"
						(submitForm)="submit()"
						[isBlock]="true"
						[isDisabled]="images.length < numberOfImages"
						[isSubmitting]="submitting"
						text="{{ 'Continue' }}"
					>
					</app-kamona-custom-button>
				</div>
			</div>
		</div>
	</div>
</ng-container>
